export default __webpack_public_path__ + "static/media/atlassian.3f88d126.svg";